import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { QueryStatus, authAxios } from "../../utils";
import { RootState } from "../../redux/store";
import { CompanyTopUps, CompanyTopUpsApi } from "./balanceLimitsApi";
import { dateFormatterDayMonthYearLong2Digits } from "@qivia/ui";

export interface BalanceLimitsState {
  companyTopUpsStatus: QueryStatus;
  companyTopUps: CompanyTopUps[];
}

const initialState: BalanceLimitsState = {
  companyTopUpsStatus: "idle",
  companyTopUps: [],
};

export const companyTopUpsAsync = createAsyncThunk(
  "companyTopUps/call",
  async () => {
    const axios = authAxios();
    const response = await axios.get<CompanyTopUpsApi[]>(`/companies/top_ups`);
    const result: CompanyTopUps[] = response.data.map((r) => {
      return {
        ...r,
        executionDate: dateFormatterDayMonthYearLong2Digits(
          new Date(r.executionDate),
        ),
        amountLimit: r.amountLimit ? (r.amountLimit / 100).toFixed(2) : null,
        lastTopUp: (r.lastTopUp.value / 100).toFixed(2),
      };
    });
    return result;
  },
);

export const balanceLimitsSlice = createSlice({
  name: "balanceLimits",
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {},
  // The `extraReducers` field lets the slice handle actions defined elsewhere,
  // including actions generated by createAsyncThunk or in other slices.
  extraReducers: (builder) => {
    builder
      .addCase(companyTopUpsAsync.pending, (state) => {
        state.companyTopUpsStatus = "processing";
      })
      .addCase(companyTopUpsAsync.fulfilled, (state, action) => {
        state.companyTopUpsStatus = "success";
        state.companyTopUps = action.payload;
      })
      .addCase(companyTopUpsAsync.rejected, (state) => {
        state.companyTopUpsStatus = "failed";
      });
  },
});

export const selectCompanyTopUps = (state: RootState) =>
  state.balanceLimits.companyTopUps;
export const selectCompanyTopUpsStatus = (state: RootState) =>
  state.balanceLimits.companyTopUpsStatus;

export default balanceLimitsSlice.reducer;
